export default function removeQueryParameter(key: string): void {
	const params = new URLSearchParams(window.location.search)
	params.delete(key)
	const newSearch = params.toString()
	if (window.location.search === `?${newSearch}`) return
	const newUrl = `${window.location.origin}${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`
	window.history.replaceState({}, document.title, newUrl)
}
